<div fxLayout="row" class="ml-12" fxFlexFill fxLayoutAlign="start center" fxHide.lt-md>
  <span class="supplier-breadcrumb" [routerLink]="['/dashboard/main']"><mat-icon class="mt-8">home</mat-icon></span>
  <span class="supplier-breadcrumb ml-4 mr-4"> > </span>
  <span *ngFor="let breadcrumb of (breadcrumbs$ | async)">
    <span class="supplier-breadcrumb mr-4" routerLink="{{ breadcrumb.url }}"> {{ breadcrumb.label }} > </span>
  </span>
</div>
